export default "__VITE_ASSET__KbcUZPx1__"